import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/tenants/$id')({
  component: RouteComponent,
});

export function RouteComponent() {
  const navigate = useNavigate();

  // Redirect to tenants list - tenants are read-only via this route
  React.useEffect(() => {
    navigate({ to: '/dashboard/tenants' });
  }, [navigate]);

  return null;
}
